// extracted by mini-css-extract-plugin
module.exports = {"divider":"DividerWithText__divider___2GkU5","spacer":"DividerWithText__spacer___3UbqS"};